import { BaseTableConfig } from './base-table-config';

export class PaginatedTableConfig extends BaseTableConfig {
  constructor() {
    super();
    this.showAdvancedSearch = true;
  }
}
